import { render } from "./Icon.vue?vue&type=template&id=60753f01"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=60753f01&lang=scss"
script.render = render

export default script